module.exports = __webpack_public_path__ + "static/img/refresh-disabled.d72d45c.svg";